export const materialTypeOptions = [
  {
    value: 'softwoodMaterial',
    label: 'Nadelholz',
  },
  {
    value: 'glulamMaterial',
    label: 'Brettschichtholz',
  },
  {
    value: 'lvlMaterial',
    label: 'Furnierschichtholz',
  },
  {
    value: 'steelMaterial',
    label: 'Stahl',
  },
]
